export default class {

    constructor({
        scrollbar, // Scrollbar background
        scrollbarThumb, // Scrollbar draggable thumb
        dragContainer, // Where the drag events are registered
        scrollContainer, // What are we scrolling when dragging
        onScroll = function () {}, // Execute this on scroll,
        smoothScrolling = true,
        xMin = 0
    } = {}) {

        this.scrollbar = document.querySelector(scrollbar);
        this.scrollbarThumb = document.querySelector(scrollbarThumb);
        this.scrollContainer = document.querySelector(scrollContainer);
        this.dragContainer = document.querySelector(dragContainer);

        this.active = false; // Are we being dragged?
        this.xOffset = 0;
        this.xInitial;
        this.xCurrent;
        this.xMin = xMin;
        this.xMax = this.scrollbar.clientWidth;
        this.onScroll = onScroll;
        this.smoothScrolling = smoothScrolling;
    }

    attachListeners() {
        this.dragContainer.addEventListener('touchstart', this, false);
        this.dragContainer.addEventListener('touchend', this, false);
        this.dragContainer.addEventListener('touchmove', this, false);

        this.dragContainer.addEventListener('mousedown', this, false);
        this.dragContainer.addEventListener('mouseup', this, false);
        this.dragContainer.addEventListener('mousemove', this, false);
    }

    detachListeners() {
        this.dragContainer.removeEventListener('touchstart', this, false);
        this.dragContainer.removeEventListener('touchend', this, false);
        this.dragContainer.removeEventListener('touchmove', this, false);

        this.dragContainer.removeEventListener('mousedown', this, false);
        this.dragContainer.removeEventListener('mouseup', this, false);
        this.dragContainer.removeEventListener('mousemove', this, false);
    }

    handleEvent(e) {
        switch (e.type) {
            case 'touchstart':
            case 'mousedown':
                this.dragStart(e);
                break;
            case 'touchend':
            case 'mouseup':
                this.dragEnd(e);
                break;
            case 'touchmove':
            case 'mousemove':
                this.drag(e);
                break;
        }
    }

    dragStart(e) {
        if (e.type === 'touchstart') {
            this.xInitial = e.touches[0].clientX - this.xOffset;
        } else {
            this.xInitial = e.clientX - this.xOffset;
        }

        if (e.target === this.scrollbarThumb) {
            this.active = true;
        }

        if (this.smoothScrolling) {
            this.scrollContainer.setAttribute('style', 'scroll-behavior: auto;');
        }
    }

    dragEnd(e) {
        this.active = false;
        this.xInitial = this.xCurrent;

        if (this.smoothScrolling) {
            this.scrollContainer.setAttribute('style', 'scroll-behavior: smooth;');
        }
    }

    drag(e) {
        if (this.active) {
            e.preventDefault();

            if (e.type === 'touchmove') {
                this.xCurrent = e.touches[0].clientX - this.xInitial;
            } else {
                this.xCurrent = e.clientX - this.xInitial;
            }

            this.xCurrent = this.boundsCheck(this.xCurrent);
            this.xOffset = this.xCurrent;

            this.setTranslate(this.xCurrent, this.scrollbarThumb);
        }
    }

    boundsCheck(x) {
        if (x < this.xMin) {
            return this.xMin;
        } else if (x > this.xMax) {
            return this.xMax;
        }

        return x;
    }

    setTranslate(x, element) {
        element.setAttribute('style', 'left: ' + x + 'px;');
        this.onScroll(x);
    }
}